// ======================================================================
// 📁 File: src/modules/ppe/components/material/boughtout/BoughtOutKpiBar.jsx
// 📝 Purpose:
//   KPI Bar for Bought-Out Item Master
//   - Total items
//   - With UOM
//   - Without UOM
//   - With Supplier Reference
// ======================================================================

import React from "react";

// ----------------------------------------------------------------------
// KPI Card (local, lightweight)
// ----------------------------------------------------------------------
const KpiCard = ({ title, value, color }) => (
  <div
    style={{
      flex: 1,
      background: "#fff",
      borderRadius: 12,
      padding: "12px 16px",
      boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
      borderLeft: `6px solid ${color}`,
    }}
  >
    <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>
      {title}
    </div>
    <div style={{ fontSize: 22, fontWeight: 600 }}>{value}</div>
  </div>
);

// ----------------------------------------------------------------------
// Bought-Out KPI Bar
// ----------------------------------------------------------------------
export default function BoughtOutKpiBar({ rows = [] }) {
  const total = rows.length;

  const withUom = rows.filter(
    (r) => r.uom && String(r.uom).trim() !== ""
  ).length;

  const withoutUom = total - withUom;

  const withSupplierRef = rows.filter(
    (r) => r.supplier_reference && String(r.supplier_reference).trim() !== ""
  ).length;

  return (
    <div
      style={{
        display: "flex",
        gap: 16,
        marginBottom: 20,
      }}
    >
      <KpiCard title="Total Bought-Out Items" value={total} color="#0f766e" />
      <KpiCard title="With UOM" value={withUom} color="#2563eb" />
      <KpiCard title="Without UOM" value={withoutUom} color="#dc2626" />
      <KpiCard
        title="With Supplier Reference"
        value={withSupplierRef}
        color="#7c3aed"
      />
    </div>
  );
}
